export const GAMMA_COLOR_DISPLAY_MIN = 0;
export const GAMMA_COLOR_DISPLAY_MAX = 100;
